/**
 * xiaofeng-os 版本号 & 更新日志
 * 
 * 规则：每次有实质性功能改动时，更新版本号和日志
 * 版本号格式：v{主版本}.{次版本}.{补丁}
 * - 主版本：架构重构、重大新系统
 * - 次版本：新增模块/面板/核心功能  
 * - 补丁：bug修复、样式调整、小优化
 */

export const APP_VERSION = 'v3.13.9';

export interface ChangelogEntry {
  version: string;
  date: string;
  changes: string[];
}

export const CHANGELOG: ChangelogEntry[] = [

  {
    version: 'v3.13.9',
    date: '2026-08-10',
    changes: [
      'P0淇: CORS鐧藉悕鍗曞姞鍥? SIGTERM鍙宖lushDB绔炴€佷慨澶? 鍚姩鐧介棯淇',
      'isZh鍔ㄦ€佹淳鐢? FloatingAgent闂寘娓呯悊',
      'useVoiceCall瀹氭椂鍣╟hurn淇',
      'AgentChatPage琛rrorBoundary',
    ],
  },

  {
    version: 'v3.13.8',
    date: '2026-08-07',
    changes: [
      '版本号统一升级：APP_VERSION 去 v 前缀根治双 v 显示 + 同步 package.json/CHANGELOG.md/交接文档',
    ],
  },

  {
    version: 'v3.13.7',
    date: '2026-08-04',
    changes: [
      'Test deployment check',
    ],
  },

  {
    version: 'v3.13.6',
    date: '2026-07-24',
    changes: [
      '修复“API key 可能无效或已过期”黄色提示框误报：此前只要消息文本含 401/apikey 字样就触发（如主动扫描播报），现限定仅真正的错误消息(source===error)才显示',
    ],
  },

  {
    version: 'v3.13.5',
    date: '2026-07-24',
    changes: [
      '语音用量 + Token 用量弹窗改为向上弹出（底边锚定按钮顶部上方），不再被底部工具栏遮挡看不见',
    ],
  },

  {
    version: 'v3.13.4',
    date: '2026-07-24',
    changes: [
      '修复语音用量面板报错 Rendered more hooks：精度监控 useEffect 误放在早返回之后导致渲染间 hooks 数量不一致，已移到所有早返回之前',
      '顺手修复 VoiceUsagePanel 最近活动区 TS18048（length 可能 undefined）',
    ],
  },

  {
    version: 'v3.13.3',
    date: '2026-07-24',
    changes: [
      '修复百炼 400 报错根因：result_format 参数已被 qwen3.7 等新模型废弃，改用 message 格式（换多少次 API key 都无效的真凶）',
      '复活本地语义引擎：修复嵌套 sharp 缺 win32-x64 二进制导致 transformers.js 无法加载，本地 embedding 从此可用',
      '新增 scripts/patch-transformers-sharp.cjs + postinstall 钩子，sharp 补丁在重装依赖后自动生效',
      '配置 HF 国内镜像（hf-mirror.com）下载 embedding 模型，解决国内访问 huggingface.co 不稳定',
      '启动时自动回填存量记忆 embedding 并注册 LSH 索引（本次实测回填 250/250 条）',
      '知识库 RAG 检索改用向量语义检索（queryMemoriesVector），提升对话中知识召回率',
      '修复 db_layer.ts beforeExit 传参编译错误；新增每 30 分钟 WAL checkpoint 防止 -wal 文件膨胀',
      '修复 chat.ts getKey 未导入导致的潜在 ReferenceError',
    ],
  },

  {
    version: 'v3.13.2',
    date: '2026-07-24',
    changes: [
      '修复右侧工作流面板卡在思考中: REST fallback 成功/失败后同步重置 workflow 状态为 idle',
      '修复 intentData 局部变量未声明导致的 TS2588 const 赋值错误',
    ],
  },

  {
    version: 'v3.13.1',
    date: '2026-07-24',
    changes: [
      '修复聊天崩溃: Cannot access activeModel before initialization (TDZ) - 重排意图路由变量声明顺序',
      '修复 finalModel const 重赋值错误 - 改为 let',
      '意图路由 suggestedProvider 使用 intentMapping.provider 保证 provider/model 一致性',
    ],
  },

  {
    version: 'v3.13.0',
    date: '2026-07-24',
    changes: [
      'P3 意图识别引擎: 三层分类器架构 (Rule Engine + Embedding + LLM Fallback) + LRU 缓存 + 性能监控 + 10s 超时保护',
      '意图识别前后端协同: AgentChatPage 集成 classifyIntent + server/chat.ts 智能模型路由 + Intent UI 可视化',
      '知识图谱 ABC 全量优化: 后端记忆去重(73>37) + 聚类分组 + 预测节点限流(46>10) + 前端节点去重 + 样式分级 + 筛选栏 + 导出 + 反馈按钮 + 语义搜索高亮',
      'P2 对话质量优化: Markdown 增强渲染 (rehype-highlight/remark-gfm/katex) + Token 精确计数+RMB 统计 + Socket 错误恢复机制 + Ctrl+K 搜索面板键盘导航',
      'P0/P1 聊天页面改造: 消息头像体系(人格融合) + 空状态文案修复 + 中英混用清理 + 附件上传 bug 根治 + 工具栏分层 + 更多页重构 + 截图入口打通 + 右键属性实现 + 搜索竞态修复',
      'MCP 配置框架: MCPConfigDialog 弹窗 + mcpConfigSchemas 统一配置 + MCP 路由三处同步 + 后端 POST /api/mcp/config/:name',
      '全局快捷键系统: useKeyboardShortcuts Hook + KeyboardSettings UI + HelpModal 帮助面板 + Ctrl+S/Ctrl+/Esc 快捷键',
      '桌面静默启动器: silent-start.bat/vbs + clean-port.ps1 进程树清理 + 桌面图标(黑金XF图标) + emergency-clean.ps1',
      'NexusGlobe lg 断点适配: p-4 md:p-6 lg:p-8 + max-w-[1400px] 居中控制',
      '代码质量优化: 删除废弃 TokenDetail.tsx + Canvas emoji 修复 + VoiceUsage 精度监控 + TokenDetail 重复显示修复',
      '聊天全屏弹窗遮挡修复: MoreCenterGrid onOpen 区分 centerView/关全屏弹窗',
      '对话 401 错误引导: 检测 API key 错误并显示 amber 提示条',
    ],
  },

  {
    version: 'v3.12.75',
    date: '2026-07-24',
    changes: [
      '修复 Graph API 导入 + Timeline map 错误',
    ],
  },

  {
    version: 'v3.12.74',
    date: '2026-07-24',
    changes: [
      '修文字聊天 auto-speak bug: useTTS 优先用服务器 TTS API 而非浏览器 speechSynthesis',
    ],
  },

  {
    version: 'v3.12.73',
    date: '2026-07-24',
    changes: [
      '修文字聊天 auto-speak bug: useTTS 优先用服务器 TTS API 而非浏览器 speechSynthesis',
    ],
  },

  {
    version: 'v3.12.72',
    date: '2026-07-23',
    changes: [
      '修复TTS Content-Type双前缀Bug(voice_routes.ts)',
    ],
  },

  {
    version: 'v3.12.71',
    date: '2026-07-23',
    changes: [
      'P3+P4补全:N3 Socket通道+N5设备面板+N6 chat设备注入+K3前端版本(已有)',
    ],
  },

  {
    version: 'v3.12.70',
    date: '2026-07-23',
    changes: [
      'P3生态构建(技能市场增强+A2A互操作协议)+P4穿戴智能体(设备管理+隐私控制+API)',
    ],
  },

  {
    version: 'v3.12.69',
    date: '2026-07-23',
    changes: [
      'P2智能跃升:G上下文工程(窗口感知+智能压缩)+H Deep Research+I自我纠错+J多智能体SOP',
    ],
  },

  {
    version: 'v3.12.68',
    date: '2026-07-23',
    changes: [
      '修复沙箱Bug:顶层return非法,改用globalThis.__resultStr捕获结果(已E2E验证)',
    ],
  },

  {
    version: 'v3.12.67',
    date: '2026-07-23',
    changes: [
      'P1剩余三项:D评测体系(用例+评分+报告)+C沙箱执行(isolated-vm)+F可视化编排(ReactFlow)',
    ],
  },

  {
    version: 'v3.12.66',
    date: '2026-07-23',
    changes: [
      'P1-E断点续跑:checkpoint持久化(SQLite)+runWithTools捕获/恢复+REST API+前端断点面板',
    ],
  },

  {
    version: 'v3.12.65',
    date: '2026-07-23',
    changes: [
      'P0地基工程:A可观测性(tracer+trace面板)+B循环韧性(护栏+LLM超时重试+整轮超时降级)',
    ],
  },

  {
    version: 'v3.12.64',
    date: '2026-07-23',
    changes: [
      'P0修复:logger.ts patchConsole对undefined参数崩溃,导致聊天全挂',
    ],
  },

  {
    version: 'v3.12.63',
    date: '2026-07-23',
    changes: [
      '诊断:chat内层catch增加堆栈日志,定位slice错误',
    ],
  },

  {
    version: 'v3.12.62',
    date: '2026-07-23',
    changes: [
      'P0修复:personalityId未定义导致聊天socket.emit崩溃,聊天功能完全失效',
    ],
  },

  {
    version: 'v3.12.61',
    date: '2026-07-22',
    changes: [
      'P0:TTS熔断+语音状态隔离',
      'P1:LLM降级链+apiFetch全量替换20文件+catch类型修正',
      'P2:TTS下载修复+ASR队列上限+Dockerfile非root+docker.sock标记',
      'P3:hook去重+Token截断+logger清理+bigram回声检测',
    ],
  },

  {
    version: 'v3.12.60',
    date: '2026-07-21',
    changes: [
      'v3.12.61: 三Bug齐修——人格汉化(engine.ts用coreMotivationZh)+聊天卡死(outer catch发agent:error)+语音限流(qwen.ts onclose通知前端)',
    ],
  },

  {
    version: 'v3.12.59',
    date: '2026-07-21',
    changes: [
      'v3.12.58.1: 加 task_group 字段修复 CosyVoice 协议',
    ],
  },

  {
    version: 'v3.12.58',
    date: '2026-07-21',
    changes: [
      'v3.12.57.1: TTS改用正确架构 cosyvoice-v3-flash + /inference + run-task/continue-task/finish-task + binary音频',
    ],
  },

  {
    version: 'v3.12.57',
    date: '2026-07-21',
    changes: [
      'v3.12.56: 用 qwen-omni-turbo-realtime-2025-03-26 (用户账户实际开通的多模态实时模型)',
    ],
  },

  {
    version: 'v3.12.56',
    date: '2026-07-21',
    changes: [
      'v3.12.56: 全面改用Qwen TTS Realtime WebSocket(废弃cosyvoice HTTP), 唤醒修正模型名qwen-asr-realtime, 防偷跑阈值改3次',
    ],
  },

  {
    version: 'v3.12.55',
    date: '2026-07-21',
    changes: [
      'v3.12.55: cosyvoice异步+TTS修复',
      'AgentChat切会话cancel+重置',
      '唤醒原生协议重写',
      '防偷跑自动关闭',
    ],
  },

  {
    version: 'v3.12.54',
    date: '2026-07-21',
    changes: [
      'v3.12.54: 语音三连修 — 删system_routes重复synthesize路由(修复试听500)+对话切换重置状态(修复卡死)+唤醒日志增强(DashScope错误定位)',
    ],
  },

  {
    version: 'v3.12.53',
    date: '2026-07-21',
    changes: [
      'v3.12.51 启动台图标美化：阴影精致化+hover动效+标签可读性+打开态光晕',
    ],
  },

  {
    version: 'v3.12.52',
    date: '2026-07-21',
    changes: [
      'v3.12.52: 语音用量5bug修复 — STT路径补stats+TTStats持久化日归零+活跃会话去重+文件转写补录',
    ],
  },

  {
    version: 'v3.12.51',
    date: '2026-07-21',
    changes: [
      'v3.12.51: TTS防刷四重修复 — synthesize加requireAuth+前端传userId+guard.js持久化重启不归零+bodyUserId补充',
    ],
  },

  {
    version: 'v3.12.50',
    date: '2026-07-21',
    changes: [
      'v3.12.49: 个人资料8项修复 — fetch→apiFetch+AbortController+卸载保护+死代码清理+对比度提升+订阅升级按钮+翻译键',
    ],
  },

  {
    version: 'v3.12.49',
    date: '2026-07-21',
    changes: [
      'v3.12.48-r2: 修复ChevronRight未导入导致个人中心报错',
    ],
  },

  {
    version: 'v3.12.48',
    date: '2026-07-21',
    changes: [
      'v3.12.48: 个人中心+用户卡片置顶+登出上移+layout优化',
    ],
  },

  {
    version: 'v3.12.47',
    date: '2026-07-21',
    changes: [
      'v3.12.47: 简化为始终可见侧边栏，去搜索框和移动端抽屉',
    ],
  },

  {
    version: 'v3.12.46',
    date: '2026-07-21',
    changes: [
      'v3.12.46-r2: 修复搜索词不清空bug',
    ],
  },

  {
    version: 'v3.12.45',
    date: '2026-07-21',
    changes: [
      'v3.12.46: 系统设置P0改造 — 响应式侧边栏+移动端抽屉+搜索+折叠动画+Section过渡+卡片网格+撤销Toast+APIKey复制确认+全局对比度',
    ],
  },

  {
    version: 'v3.12.44',
    date: '2026-07-21',
    changes: [
      'v3.12.45: 修复addRow快照丢失编辑历史+撤销位置漂移+测通按钮占位符禁用',
    ],
  },

  {
    version: 'v3.12.43',
    date: '2026-07-21',
    changes: [
      'v3.12.44: 设备按钮P0改造 — 删除确认弹窗/取消编辑/未保存提醒/表单验证/Skeleton+Error态/在线状态/测通按钮/暗色对比度',
    ],
  },

  {
    version: 'v3.12.42',
    date: '2026-07-21',
    changes: [
      'v3.12.44: 内核监控6项审计修复 — fetch超时+toFixed保护+LiveStats补字段+网络速率防Infinity+error状态+WS info缓存',
    ],
  },

  {
    version: 'v3.12.41',
    date: '2026-07-21',
    changes: [
      'v3.12.43: 修复RemoteMCPSettings useCallback未导入导致设备按钮报错',
    ],
  },

  {
    version: 'v3.12.40',
    date: '2026-07-21',
    changes: [
      'v3.12.42: 修复iPad桌面模式误加载DesktopUI（UA嗅探+iPad/iPhone/Android强制Mobile）',
    ],
  },

  {
    version: 'v3.12.39',
    date: '2026-07-21',
    changes: [
      'v3.12.41: 移动端平板响应式修复（JS断点1280+CSS contain降级）',
    ],
  },

  {
    version: 'v3.12.38',
    date: '2026-07-20',
    changes: [
      '内核监控大改：6指标卡片-CPU-RAM-磁盘-网络-交换-系统信息+CPU历史颜色分级+磁盘挂载详情表+Docker容器面板+后端Docker采集集成',
    ],
  },

  {
    version: 'v3.12.37',
    date: '2026-07-20',
    changes: [
      '启动台图标美化-CSS微调-v3.12.38',
    ],
  },

  {
    version: 'v3.12.36',
    date: '2026-07-20',
    changes: [
      'fix: --date z-index',
    ],
  },

  {
    version: 'v3.12.28',
    date: '2026-07-19',
    changes: [
      'v3.12.27 日志系统Docker重建生效 结构化JSON+持久化+console劫持',
    ],
  },

  {
    version: 'v3.12.27',
    date: '2026-07-19',
    changes: [
      'v3.12.26 统一日志系统 结构化JSON+文件持久化+按天轮转+console劫持',
    ],
  },

  {
    version: 'v3.12.25',
    date: '2026-07-19',
    changes: [
      'v3.12.24 最后6处String(e)/.message清剿 agent+files+iot',
    ],
  },

  {
    version: 'v3.12.24',
    date: '2026-07-19',
    changes: [
      '第七次扫描最后6处String(e)/.message清剿: agent_routes×2+files_routes×3+iot_routes×1',
    ],
  },
  {
    version: 'v3.12.23',
    date: '2026-07-19',
    changes: [
      'v3.12.22 String(e)/.message暴露彻底清零 19路由文件~116处→安全消息',
    ],
  },

  {
    version: 'v3.12.22',
    date: '2026-07-19',
    changes: [
      'String(e)/.message暴露彻底清零: 19路由文件~116处→安全消息 三专家交叉验证+3轮脚本清扫',
      '覆盖: agent/branch/chat/contacts/conversations/files/iot/mcp/marketplace/misc/notifications/personality/prefs/skill/system/voice/user_settings/memory/music',
    ],
  },
  {
    version: 'v3.12.21',
    date: '2026-07-19',
    changes: [
      'v3.12.20 第三轮微残留全部清零 12+处 String(e)/ok→success/重复import/localStorage',
    ],
  },

  {
    version: 'v3.12.20',
    date: '2026-07-19',
    changes: [
      '第三轮扫描微残留一键清零: Math.random漏1+重复import+localStorage try-catch+String(e)清零+{ok→success}',
    ],
  },
  {
    version: 'v3.12.19',
    date: '2026-07-19',
    changes: [
      'v3.12.18 P2端点安全加固 7端点校验+autonomy错误安全化+jwt日志去敏+preferences响应统一',
    ],
  },

  {
    version: 'v3.12.18',
    date: '2026-07-19',
    changes: [
      'P2: 7端点输入校验加固(agent/interactions/preferences/device/contacts/autonomy/notifications)',
      'autonomy_routes String(e)暴露错误→安全消息(7处)+preferences {ok→success}+jwt日志去路径',
      '跳过: 裸fetch(60+文件风险大)+前端动画Math.random(行业惯例)',
    ],
  },
  {
    version: 'v3.12.17',
    date: '2026-07-19',
    changes: [
      'v3.12.16 P1前端ID生成Math.random→crypto.randomUUID()清零(8文件18处)',
    ],
  },

  {
    version: 'v3.12.16',
    date: '2026-07-19',
    changes: [
      'P1: 前端ID生成Math.random→crypto.randomUUID()清0（8文件18处）',
      '覆盖: AgentChatPage/DesktopUI/AppContext/ChatPanel/LegalHub/CentralXfChat/socketService/legalCaseStore',
    ],
  },
  {
    version: 'v3.12.15',
    date: '2026-07-19',
    changes: [
      'v3.12.14 P0后端Math.random彻底清零约40处+feedback端点安全加固+JSON.parse安全(3处)',
    ],
  },

  {
    version: 'v3.12.14',
    date: '2026-07-19',
    changes: [
      '第二轮扫描P0: 后端Math.random彻底清零(~40处，仅保留retry/lsh算法)+反馈端点加认证/长度校验',
      'JSON.parse安全加固(db_layer+2处)+6路由crypto化+20+工具/Agent/STT/socket全量清零',
      '保留: retry.ts网络jitter(行业惯例) + lsh_index.ts Box-Muller(数学算法)',
    ],
  },
  {
    version: 'v3.12.13',
    date: '2026-07-19',
    changes: [
      'v3.12.12 全量深扫一次性修复26项: Math.random→crypto(7处)+auth校验(3)+fetch→apiFetch(3)+db JSON.parse安全(1)+空catch→warn(8)+重复import合并',
    ],
  },

  {
    version: 'v3.12.12',
    date: '2026-07-19',
    changes: [
      '全量深度扫描一次性修复26项: Math.random→crypto(7处)+auth输入校验(3)+裸fetch→apiFetch(3)+db_layer JSON.parse安全(1)',
      '空catch吞异常→console.warn(8处)+AgentChatPage重复import合并',
      'P2: useWakeWord+useMusicPlayer验证为可接受模式(不修)',
    ],
  },

  {
    version: 'v3.12.11',
    date: '2026-07-19',
    changes: [
      'P0: JWT Secret 持久化 + leads 默认密钥移除 + ErrorBoundary 包裹三入口 + 11处 fetch→apiFetch + ClockContext + apiClient 超时',
      'P1: MobilePlatform ChevronDown 导入修复 + UID crypto.randomBytes + 密码强度校验 + OSWindow 拖拽监听器泄漏修复',
      'P1: 壁纸 base64 Canvas 压缩存储（防 localStorage 5MB 溢出）+ toast id 问题评估',
      'P2: z-index CSS 令牌体系 + 主题切换平滑过渡 + ErrorBoundary 硬编码字符串 i18n + translations 新增键',
    ],
  },
  {
    version: 'v3.12.10',
    date: '2026-07-19',
    changes: [
      'fix(P0): JWT Secret 生产化持久化 — dev随机/production读data/jwt.secret(chmod 0o600)',
      'fix(P0): leads_routes 移除硬编码默认密钥 local-dev',
      'fix(P0): apiClient 超时适配 — FormData/Blob 自动5min，普通15s',
      'fix(P0): 11处裸 fetch→apiFetch（DesktopUI+AgentChatPage+NodeDetailPanel）',
      'fix(P0): ErrorBoundary 包裹三巨头入口，子组件崩不拖垮桌面',
      'feat(P0): ClockContext 隔离 time，消除每秒全量重渲染',
    ],
  },

  {
    version: 'v3.6.74',
    date: '2026-07-17',
    changes: [
      'feat: 模块日志系统(ring buffer),7个tab:全部/LLM/STT/TTS/工具/Socket/调度器',
      'feat: 各模块接入日志(LLM adapter/STT wake_detector/Socket/Scheduler)',
    ],
  },


  {
    version: 'v3.6.74',
    date: '2026-07-17',
    changes: [
      'feat: 模块日志系统(ring buffer),7个tab:全部/LLM/STT/TTS/工具/Socket/调度器',
      'feat: 各模块接入日志(LLM adapter/STT wake_detector/Socket/Scheduler)',
    ],
  },


  {
    version: 'v3.6.74',
    date: '2026-07-17',
    changes: [
      'fix: ModelSelector dropdown 加宽 min-w 180->260 + provider 标签 min-w-60px,让\"DeepSeek\"全称不被截断(之前显示成 DEEPSEE)',
    ],
  },

  {
    version: 'v3.6.72',
    date: '2026-07-17',
    changes: [
      'fix: ModelSelector dropdown 重复显示 (entry.label 含 provider 又叠 provider 标签),getDisplayLabel 只返回模型名',
    ],
  },

  {
    version: 'v3.6.71',
    date: '2026-07-17',
    changes: [
      'fix: ModelSelector PROVIDER_LABELS 改全称 (DS->DeepSeek, QW->Qwen, GPT->OpenAI 等)',
      'fix: MODEL_SHORT_NAMES 改全称 (V3->DeepSeek-V3, V4 Flash->DeepSeek-V4-Flash 等),不再截断 8 字符',
    ],
  },

  {
    version: 'v3.6.70',
    date: '2026-07-17',
    changes: [
      'feat: 语音调用量统计面板(VoiceUsagePanel),STT+TTS 实时费用+数据统计',
      'feat: server/tts/stats.ts TTS 调用统计 + /api/voice/usage 统一端点',
      'feat: 工具栏 Token 按钮后新增\"语音用量\"按钮(Volume2 图标+文字)',
    ],
  },

  {
    version: 'v3.6.69',
    date: '2026-07-17',
    changes: [
      'fix: X 关闭按钮加深 (text-white/30 -> text-white/70) + 加大 14->16 + 加 border + hover 红色,更醒目',
      'fix: 5 个分类即使 0 值也显示 (用 opacity-40 让 0 淡),结构完整呈现',
    ],
  },

  {
    version: 'v3.6.68',
    date: '2026-07-17',
    changes: [
      'feat: TokenUsagePanel 用 React Portal + fixed 定位到 Token 按钮右侧(同一水平线,完全脱离原位置)',
      'feat: TokenUsagePanel 面板内容参考 WB 设计:大百分比+已使用/总量+5分类+关闭按钮+丰富元信息',
    ],
  },

  {
    version: 'v3.6.67',
    date: '2026-07-17',
    changes: [
      'fix: 去掉输入框 onChange auto-grow(输入文字后高度不会回缩,保持用户拖拽的高度)',
      'fix: TokenUsagePanel 改 fixed bottom-4 right-4(屏幕右下角,完全避开所有聊天 UI)',
    ],
  },

  {
    version: 'v3.6.66',
    date: '2026-07-17',
    changes: [
      'fix: TokenUsagePanel 向下弹出(避开上方段控器) + 缩窄到 w-56 + max-h-40vh',
      'fix: 输入框默认高度 44->120(约 4 行,更宽敞)',
      'fix: 发送按钮 canSend 逻辑(确认 draftText state 化后正常工作)',
    ],
  },

  {
    version: 'v3.6.65',
    date: '2026-07-17',
    changes: [
      'fix: 增强提示词 body 改用服务端读的 prompt 字段(原 text 字段被忽略,导致 LLM 收到空 user 消息,personality prompt 主导返回无关内容)',
      'fix: TokenUsagePanel 缩窄 72->60 + max-h-60vh + scrollbar,避免遮挡工具栏段控器',
    ],
  },

  {
    version: 'v3.6.64',
    date: '2026-07-17',
    changes: [
      'fix: draftText state 化(不再用 ref 当受控 prop),修发送按钮无反应+增强提示词与输入无关双 bug',
      'feat: 输入框可上下拖拽调高度(localStorage 持久化,双击手柄重置)',
    ],
  },

  {
    version: 'v3.6.63',
    date: '2026-07-17',
    changes: [
      'TDZ7-5-useState-centralize',
    ],
  },

  {
    version: 'v3.6.62',
    date: '2026-07-17',
    changes: [
      'fix v3.6.62:AgentChatPage 5个散落useState集中+死代码删除(sourcemap反查mr=earlierOffset TDZ)',
    ],
  },

  {
    version: 'v3.6.61',
    date: '2026-07-17',
    changes: [
      'fix v3.6.61:AgentChatPage displayMessages前向引用TDZ(sourcemap反查629:16,handleBatchCopy上移)',
    ],
  },

  {
    version: 'v3.6.60',
    date: '2026-07-17',
    changes: [
      'fix v3.6.60:5洞同治TDZ(StrictMode prod+manualChunks全清+mermaid独立+sourcemap+stack显示)',
    ],
  },

  {
    version: 'v3.6.59',
    date: '2026-07-17',
    changes: [
      'fix vite motion chunk:framer-motion v12 preRender schedule跨chunk TDZ(Er before init),改为inline',
    ],
  },

  {
    version: 'v3.6.58',
    date: '2026-07-17',
    changes: [
      '重部署修复chat按钮TDZ:服务器旧bundle残留',
    ],
  },

  {
    version: 'v3.6.57',
    date: '2026-07-17',
    changes: [
      '暂缓修复:crypto随机密钥',
      'socketRef桥接',
      'btoa优化',
      'TS5.9',
      'build脚本',
      'version认证',
      'Wand2导入',
      'ws_sync密钥',
      '扫描发现的3个新问题',
    ],
  },

  {
    version: 'v3.6.56',
    date: '2026-07-17',
    changes: [
      'deploy脚本修复+P2修复:autonomy/music路由try-catch',
      'Mermaid安全加固',
      'JWT密钥强制',
      'vite-chunk拆分',
    ],
  },

  {
    version: 'v3.6.55',
    date: '2026-07-17',
    changes: [
      'P1修复: skill路由加requireAuth + LLM调用60s超时',
      'P1修复: apiClient AbortController每次重试新建 + systemStats竞态useRef',
      'P1修复: useMusicPlayer _audio引用计数清理 + WS事件错误边界',
    ],
  },

  {
    version: 'v3.6.54',
    date: '2026-07-17',
    changes: [
      'P0修复12项: stale closure消息截断 + 历史去重 + requireAuth导入 + non-null崩溃',
      '密钥泄漏修复: .env占位符化 + bootstrap不打印密码 + wecom不log token',
      '安全加固: mcp/files路由加requireAuth + .dockerignore排除敏感文件',
      '部署修复: Dockerfile sharp版本动态化 + .gitignore移除package-lock排除',
    ],
  },

  {
    version: 'v3.6.53',
    date: '2026-07-16',
    changes: [
      'chat enhance phase1 edit regenerate feedback codeblockcopy mention shortcut paste',
    ],
  },

  {
    version: 'v3.6.52',
    date: '2026-07-16',
    changes: [
      'fix TDZ useRef enable not yet declared',
    ],
  },

  {
    version: 'v3.6.51',
    date: '2026-07-16',
    changes: [
      'fix STT cost leak base64 useRef session guard monitor card',
    ],
  },

  {
    version: 'v3.6.50',
    date: '2026-07-16',
    changes: [
      '\'🔥 修复STT计费泄漏(三层bug)— base64编码+useRef去重+session守卫',
      '📊 新增STT用量监控卡片',
    ],
  },

  {
    version: 'v3.6.49',
    date: '2026-07-16',
    changes: [
      '修voice同步:AgentChatPage顶部选择语音按钮改用AppContext(删除本地state,统一selectedVoiceId来源)',
      '修playPreview 15秒超时(避免TTS后端卡死导致Loader2永远转)+toast错误提示',
    ],
  },

  {
    version: 'v3.6.48',
    date: '2026-07-16',
    changes: [
      '修复Dockerfile:加npm_config_node_gyp_url指npmmirror,避免nodejs.org被墙导致sqlite3@6.0.1 node-gyp编译超时失败',
    ],
  },

  {
    version: 'v3.6.47',
    date: '2026-07-16',
    changes: [
      '三处同步的\'自动语音回复\'开关:设置-语音服务(挪到顶部首项) + 首页声音设置(SoundPanel完整开关) + 对话顶部(选择语音旁mini图标按钮)',
      '状态共享AppContext自动同步,默认关闭',
    ],
  },

  {
    version: 'v3.6.46',
    date: '2026-07-16',
    changes: [
      '新增自动语音回复总开关(默认关闭)：聊天页与浮窗回复不再自动朗读，可在设置-语音中开启',
    ],
  },

  {
    version: 'v3.6.45',
    date: '2026-07-16',
    changes: [
      '修复对话发送后无回复:server/conversation/manager.ts的addMessage函数内conversationId裸引用(应为msg.conversationId)改为msg.conversationId(2处)',
    ],
  },

  {
    version: 'v3.6.44',
    date: '2026-07-16',
    changes: [
      '唤醒词麦克风不可用(非安全上下文)友好提示:引导改用https://os.aizjyun.cn',
      '错误条改琥珀色非致命',
    ],
  },

  {
    version: 'v3.6.43',
    date: '2026-07-16',
    changes: [
      '修复首页语音加载失败误报(初始加载静默,失败内联+重试,移除全局toast)',
      '语音服务设置优化:密钥眼睛显隐+脱敏预览',
      '修正豆包/通义千问(DashScope)命名并标注二选一',
      '移除voice_routes与system_routes重复的/voice/active-provider路由',
    ],
  },

  {
    version: 'v3.6.42',
    date: '2026-07-16',
    changes: [
      '移除admin后门兜底',
      'JWT_SECRET轮换失效旧token',
      '重建修复首页q --version TDZ旧构建',
      '部署加固防数据丢失',
    ],
  },

  {
    version: 'v3.6.41',
    date: '2026-07-16',
    changes: [
      '知识库第二按钮深度优化:修复层级下拉中文值导致400(K-1)',
      '内联面板替代prompt编辑与移动(K-2)',
      '3D记忆树frameloop=demand加自适应DPR加节点超120自动降配(A2)',
      '批量吸收并发池限3加进度toast(C1)',
      '文件列表建索引O(1)匹配(C2)',
      '新增memory/search语义检索加关键词与语义切换(B3)',
      'memories:changed防抖800ms加操作后刷新叙事时间线(D1)',
    ],
  },

  {
    version: 'v3.6.40',
    date: '2026-07-16',
    changes: [
      '知识库(第二按钮)深度优化:修复层级下拉中文值导致400(K-1)',
      '内联面板替代prompt编辑/移动(K-2)',
      '3D记忆树frameloop=demand+自适应DPR+节点超120自动降配(A2)',
      '批量吸收并发池限3+进度toast(C1)',
      '文件列表建索引O(1)匹配(C2)',
      '新增/api/memory/search语义检索+关键词与语义切换(B3)',
      'memories:changed防抖800ms+操作后刷新叙事时间线(D1)',
    ],
  },

  {
    version: 'v3.6.39',
    date: '2026-07-16',
    changes: [
      '中枢深度优化:语义化聚类布局(真实agents渲染)+活跃度三联动+脉冲仅活跃弧流动',
      '修复重复订阅(B-1)/NaN塌点(V-1)/O(n)查找(V-2)/材质泄漏(V-3)',
      '下钻组织层接真实组织名(C1)+记忆条数复活(C-2)',
    ],
  },

  {
    version: 'v3.6.38',
    date: '2026-07-15',
    changes: [
      'F+G --version 中枢实时脉冲与下钻(修复agent_routes构建错误)',
    ],
  },

  {
    version: 'v3.6.37',
    date: '2026-07-15',
    changes: [
      '\'修复agent_routes解析错误,中枢F+G正式部署\'',
    ],
  },

  {
    version: 'v3.6.36',
    date: '2026-07-15',
    changes: [
      '\'中枢F实时脉冲+G视图下钻(清理部署临时文件)\'',
    ],
  },

  {
    version: 'v3.6.35',
    date: '2026-07-15',
    changes: [
      '\'中枢F实时脉冲+G视图下钻\'',
    ],
  },

  {
    version: 'v3.6.34',
    date: '2026-07-15',
    changes: [
      '关闭无条件自动admin登录后门(仅显式配置AUTO_LOGIN_PASSWORD才自动登录否则403)',
      '加固部署防数据丢失(SCP排除data/.env+部署前后user数一致性校验)',
      '记录中枢2项待办F实时脉冲+G视图下钻',
    ],
  },

  {
    version: 'v3.6.33',
    date: '2026-07-15',
    changes: [
      '修复 Web 端退出登录跳转营销落地页：桌面浏览器(含访客)始终渲染 DesktopUI，登出复位到桌面首页',
    ],
  },

  {
    version: 'v3.6.32',
    date: '2026-07-15',
    changes: [
      '屏幕适配(横/竖屏响应式) + D节点点击修复(0.05半径+命中区) + 知识库buildTree兜底+401降级',
    ],
  },

  {
    version: 'v3.6.31',
    date: '2026-07-15',
    changes: [
      '屏幕适配(横/竖屏响应式) + D节点点击修复(0.05半径+命中区) + 知识库buildTree兜底+401降级',
    ],
  },

  {
    version: 'v3.6.30',
    date: '2026-07-15',
    changes: [
      '屏幕适配(横/竖屏响应式) + D节点点击修复(0.05半径+命中区) + 知识库buildTree兜底+401降级',
    ],
  },

  {
    version: 'v3.6.29',
    date: '2026-07-15',
    changes: [
      '屏幕适配(横/竖屏响应式) + D节点点击修复(0.05半径+命中区) + 知识库buildTree兜底+401降级',
    ],
  },

  {
    version: 'v3.6.28',
    date: '2026-07-15',
    changes: [
      '修复web登录态桌面按钮路由:登录后无条件渲染DesktopUI,所有tab(org/settings/skills/knowledge/chat等)由DesktopUI自管理,不再掉回web落地页',
    ],
  },

  {
    version: 'v3.6.27',
    date: '2026-07-14',
    changes: [
      '恢复web登录态首页为OS桌面(DesktopUI)替代对话工作台(AppLayout)',
      '保留web构建与四症状修复',
    ],
  },

  {
    version: 'v3.6.26',
    date: '2026-07-14',
    changes: [
      '修复前端构建目标desktop转web',
      '注入XF_FRONTEND_TARGET与DEEPSEEK密钥',
      '数据目录迁移至卷',
      '新建yupai账号',
    ],
  },

  {
    version: 'v3.6.25',
    date: '2026-07-14',
    changes: [
      '加固system:stats广播: setInterval加unref避免阻止进程退出',
      '连接处理器加一次性注册守卫避免重复挂载堆叠',
    ],
  },

  {
    version: 'v3.6.24',
    date: '2026-07-14',
    changes: [
      '修复三端系统资源卡片字段错位',
      '统一SystemStats数据源+Socket实时同步',
    ],
  },

  {
    version: 'v3.6.23',
    date: '2026-07-14',
    changes: [
      '平板iPad竖屏适配: 响应式断点768→1024, 竖屏自动走移动端UI',
    ],
  },

  {
    version: 'v3.6.22',
    date: '2026-07-13',
    changes: [
      '修复initLshIndex导入缺失导致容器重启循环',
      '新增/api/admin/flush-db管理端点',
    ],
  },

  {
    version: 'v3.6.21',
    date: '2026-07-13',
    changes: [
      '修复H3关联图衰减失效bug: decayAllAssociations漏导出导致30分钟定时器ReferenceError',
    ],
  },

  {
    version: 'v3.6.20',
    date: '2026-07-13',
    changes: [
      '📊 神经合成面板统一抓取部署服务器资源（CPU/内存/磁盘/负载/网络/交换），彻底移除 GPU 小组件',
    ],
  },

  {
    version: 'v3.6.19',
    date: '2026-07-13',
    changes: [
      '清理 translations.ts 中已无人引用的 Google 登录/分隔符死字符串，彻底移除 Google 残留',
    ],
  },

  {
    version: 'v3.6.18',
    date: '2026-07-13',
    changes: [
      '修复登录入口组件未闭合标签（误删自闭合/>）导致构建失败；登录仅保留账号密码，移除 Google 按钮，apiFetch 增加15s超时根治一直转圈',
    ],
  },

  {
    version: 'v3.6.17',
    date: '2026-07-13',
    changes: [
      '修复登录一直转圈：apiFetch 增加15s超时，请求挂起不再无限转圈；移除 Google 登录按钮，登录仅保留账号密码',
    ],
  },

  {
    version: 'v3.6.16',
    date: '2026-07-13',
    changes: [
      '穿戴与车控独立卡片化；设置-通用新增显示智能穿戴/显示智能车控开关（默认关闭，置于显示米家设备上方）',
    ],
  },

  {
    version: 'v3.6.15',
    date: '2026-07-13',
    changes: [
      '启动动画枫叶品牌美化',
      '修复重连常驻bug',
      '设置跟随账号上云',
    ],
  },
  {
    version: 'v3.6.13',
    date: '2026-07-12',
    changes: [
      '🛡️ OOM 内存防护体系落地（稳定性大修复）— db_layer 读 BLOB 改 Float32Array（embedding 内存降至 1/8）；interactions 硬上限 20000 + 周期 pruneOldData 清理旧交互/记忆/Token用量；关联图每记忆上限 300 + 周期 decayAllAssociations 衰减弱关联；writeDB 移除整库深拷贝回滚（避免双倍内存）',
      '📊 新增堆内存监控（HeapMon）— 每 5 分钟打印 RSS / V8 堆用量 + 核心结构体量（interactions/memories/tokenUsage），超 1500MB RSS 升级为 WARN，OOM 复现时一眼判断是基线偏高还是持续增长',
    ],
  },
  {
    version: 'v3.6.12',
    date: '2026-07-12',
    changes: [
      '✨ 聊天侧边栏新增「返回桌面」按钮（头部与折叠态 rail 各一个），对话全屏内可一键退出回桌面',
      '🐞 修复聊天侧边栏设置按钮点击无效（根因：设置是独立 OSWindow 默认 zIndex=10，被不透明对话全屏 z-[400] 盖住看不到）—— 现点击设置先关闭对话全屏再打开设置窗口',
    ],
  },

  {
    version: 'v3.6.11',
    date: '2026-07-12',
    changes: [
      '🐞 修复设置等窗口弹窗整体偏下、需手动上拖才能看全（根因：OSWindow 初始位置写死 innerHeight*0.3 且不钳制，矮视口下底部被 Dock 裁切）—— 改为打开时按窗口尺寸在视口内水平+垂直居中，并预留顶部状态栏(56px)与底部 Dock(104px)安全区，超高窗口顶栏仍可见、可拖拽',
      '🐞 修复聊天全屏中点侧边栏功能（技能/项目空间/自动化/更多）中央面板透出首页桌面（根因：#chat-fullscreen-root 仅 fixed inset-0 z-[400] flex 无背景色，中央内容区透明时桌面透出）—— 给对话全屏根加不透明底色 bg-[#05050a]，中央面板不再透出桌面',
    ],
  },

  {
    version: 'v3.6.10',
    date: '2026-07-12',
    changes: [
      '🐞 修复居中弹窗仍偏下（v3.6.9 修复无效的根因）— 此前把 overflow/max-height 加在了 flex 的 overlay 上，触发「超高子元素顶部裁切不可滚动」经典 bug；现改为给弹窗卡片本体加 max-height: calc(100vh - 8.5rem) + overflow-y:auto（与主题中心 max-h-[85vh] 内部滚动一致），矮视口/超高内容时卡片内部滚动、垂直居中、不再偏下',
      '🐞 修复对话侧边栏「移动到项目」浮层仍被桌面压住（v3.6.9 修复无效的根因）— 此前 portal 进 #chat-fullscreen-root（z-400 层叠上下文）把浮层锁死在 z-400 层内；现改为 portal 到 document.body + z-[99999]（对齐工具授权弹窗的置顶层惯例），绝对浮于桌面 chrome 与聊天内容之上',
    ],
  },

  {
    version: 'v3.6.9',
    date: '2026-07-12',
    changes: [
      '🪟 居中弹窗对齐主题中心（根治偏下/裁切）— 新增全局规则：所有 fixed 居中弹窗预留顶部状态栏(4rem)与底部 dock(4.5rem)安全区，超高时容器内部可滚动且子元素 margin:auto 保持垂直居中，与主题中心(max-h-[85vh])表现一致，矮视口下不再顶部被切导致“偏下”',
      '🐞 修复对话侧边栏功能浮层被桌面压住（严重）— 「移动到项目」等下拉改用 createPortal 渲染到对话全屏根 #chat-fullscreen-root 并以 fixed 定位 z-[500]，对话全屏层 z-[310]→z-[400]，侧边栏根 relative z-[30]、内容面板 relative z-[10]，浮层绝对位于聊天内容与桌面 chrome 之上',
    ],
  },

  {
    version: 'v3.6.8',
    date: '2026-07-12',
    changes: [
      '🪟 弹窗布局对齐主题中心 — 撤销 v3.6.7 误加的全局「顶部推动」规则，所有 fixed 居中弹窗（登录/工具授权/确认框等）恢复与主题中心一致的垂直居中、p-4 边距、内部超高可滚动，不再偏上',
      '🐞 修复知识库显示在桌面背后（严重 bug）— 知识库入口动画由脆弱的 clipPath 圆形揭示改为 opacity+scale 淡入（保证任何情况下最终态 100% 可见），根层级 z-[200]→z-[300] 明确压在桌面 chrome 之上',
      '🐞 修复对话全屏层/侧边栏功能按钮显示层错误 — 对话全屏层 z-[210]→z-[310]；侧边栏「移动到项目」等下拉浮层 z-30→z-[60]，不再被聊天面板压住',
    ],
  },

  {
    version: 'v3.6.7',
    date: '2026-07-12',
    changes: [
      '🪟 全局弹窗垂直布局优化 — 所有 fixed 居中弹窗（技能详情/工具授权/登录/确认框等）整体上移并预留顶部状态栏与底部 dock 的安全区，内容超高时容器内部可滚动，彻底解决此前内容偏下、上下边缘被遮挡的问题',
    ],
  },

  {
    version: 'v3.6.6',
    date: '2026-07-12',
    changes: [
      '🔧 修复首页桌面图标重叠 — 工作流/获客平台等图标此前拖拽后 localStorage 残留重叠坐标导致重叠；新增网格吸附（落点对齐 130×120 网格）+ 渲染时自动去重叠（冲突坐标右移避让），刷新即自动分离，无需手动清缓存',
    ],
  },

  {
    version: 'v3.6.5',
    date: '2026-07-12',
    changes: [
      '🔐 登录中心基础优化 — 错误态（字段级红框+行内提示，保留顶部服务端错误 banner）、表单校验（用户名必填+格式、密码必填+最小 6 位长度）、密码可见性（显示/隐藏切换 Eye/EyeOff，登录与注册共用）',
    ],
  },

  {
    version: 'v3.6.4',
    date: '2026-07-12',
    changes: [
      '💬 对话功能开放式优化（方案B 聚焦版）发布 — bug专家复查最近改动，修复 /conversations/:id/messages 分页 hasMore 判断错误（offset=0 时永远为 false，导致「加载更早」按钮失效），并重建此前因 CRLF 假成功而丢失的 7 项前端优化：草稿按会话持久化、历史分页加载（渲染上限 80→200 + 加载更早按钮）、工具栏引用/@技能/@连接器回填、REST 兜底答案去重、对话更新广播侧边栏刷新、流式渲染 rAF 节流',
      '🔧 后端消除 REST 数据孤岛 — /ai/chat、/chat 问答现复用 manager 持久化写入 DB/记忆（此前 REST 链路完全不落库）',
      '🔍 搜索语义统一 — 全局 Socket 与 REST /conversations/search 共用 tokenizeQuery（Intl.Segmenter 中文分词）+ matchesAllTokens，召回一致',
    ],
  },

  {
    version: 'v3.6.3',
    date: '2026-07-12',
    changes: [
      '💬 对话侧边栏深度优化（A~G 七模块）— 后端新增 POST /conversations（创建对话，支持 title/projectId/agentId）与 PATCH /conversations/:id（置顶/收藏/改名），Conversation 类型加 pinned/starred',
      '🔍 A 搜索 — 顶部搜索框 300ms 防抖接后端 /conversations/search，命中消息内容+标题实时筛选',
      '🗂️ B 分组/筛选 — 全部/置顶/收藏 tabs；对话按 今天/昨天/本周/更早 时间分组，置顶项常驻顶部',
      '📌 C 置顶/收藏/批量 — 每会话星标/置顶按钮；批量模式多选→批量删除/移动到项目',
      '📁 D 项目空间增强 — 项目内联重命名、删除确认、项目内「+」直接建对话并打开',
      '✅ E 任务可交互 — 侧边栏建任务/进度条/点任务跳自动化中心/一键新建关联对话/删任务（后端 plans 接口已齐）',
      '⚡ G 技能快捷 — 列出已启用技能，点击直接开对话并预填 @技能名；折叠态导航加未读角标（chat=会话数、automation=运行任务数）+ 当前视图高亮',
    ],
  },
  {
    version: 'v3.6.2',
    date: '2026-07-12',
    changes: [
      '💬 对话浮层侧边栏「弹窗→中央切换」（WorkBuddy 风格）— 点技能中心/项目空间/自动化/更多不再关聊天、不再弹浮窗，直接在中央换面板：chat=AgentChatPage，ecosystem=复用 ProjectSpace，skills=复用 SkillCenter，automation=ExecutionWorkQueue+ReminderPanel 组合，more=MoreCenterGrid（复用现有 OS 窗口）',
      '🐞 修复对话「发一句不显示」— 新会话首条消息→服务器推 conversation_updated→父组件把会话 id 变真实值→加载 effect 命中 setMessages([]) 清空重载冲掉流式消息；修复：onConversationUpdated 新会话分支先写 lastLoadedConvIdRef 跳过清空，保住流式消息',
      '🔧 底部工具栏死按钮做真功能 — 引用对话=列出最近消息点选插入引用块；技能下拉=点击插入 @技能名；连接器下拉=点击插入 @连接器；+图片/+文件分别施加 image/* 与 */* 过滤',
      '🐞 顺手修历史 bug — automation/more 两个 windowId 此前未在窗口系统注册，点开是空窗；现 automation 走真实组合面板、more 网格移除空窗项',
    ],
  },
  {
    version: 'v3.6.1',
    date: '2026-07-12',
    changes: [
      '🐞 修复桌面端点底部菜单「对话」渲染错误 — ChatSidebar 的 navSections 使用 <Workflow> 图标但顶部 lucide-react 的 import 漏导入，点击「对话」打开聊天 overlay 时 React 抛出 "Element type is invalid" 被 ErrorBoundary 捕获显示「组件渲染失败」，已补上 Workflow 导入，read_lints 零错误',
    ],
  },
  {
    version: 'v3.6.0',
    date: '2026-07-12',
    changes: [
      '💬 统一对话侧边栏（ChatSidebar）— Web 与桌面端对话界面一体化：新建对话 → 导航(助理/项目空间/技能/自动化/更多) → 任务记录(历史对话) → 项目空间(可折叠区块，列项目+懒加载其对话+内联新建项目+全部跳转) → 设置，自带收起为 52px 图标 rail',
      '🗂️ 项目空间区块 — 点击项目懒加载该项目下对话(listProjectConversations)，全局任务节点(listProjectPlans) 同款折叠交互，全程 celestial-* token + 双语',
      '🔳 AgentChatPage 新增 embedded 定位属性 — embedded 时根节点 relative h-full flex-1 填满侧边栏右侧容器，否则保持原 fixed inset-0 全屏',
      '🖥️ 桌面端聊天 overlay 包裹 ChatSidebar + AgentChatPage(embedded)，接 setSearchConvId/toggleWindow 回调；新增 ecosystem 窗口(1100×750) 渲染完整 ProjectSpace「查看全部项目」',
      '🗑️ 删除旧 Sidebar.tsx（已被 ChatSidebar 取代）',
    ],
  },
  {
    version: 'v3.5.0',
    date: '2026-07-11',
    changes: [
      '🧭 桌面导航扩展 — 左上图标组新增 6 个功能入口：获客工作台 / 工作流 / 文件管理器 / 日历 / 截图录屏 / 统计，图标风格与桌面端统一（lucide 图标 + 同款渐变）',
      '📈 获客工作台（GrowthWorkbench）— 小红书 SOP 六步流水线可视化 + 一键触发「小红书获客」对话 + CRM 线索列表（对接 /api/leads）',
      '🔧 工作流编排入口 — 桌面图标复用 WorkflowPanel，可视化自动化编排',
      '📁 文件管理器入口 — 桌面图标复用 SystemExplorer，快速浏览文件系统',
      '📅 日历面板（CalendarPanel）— 月历视图 + 本地事件增删，整合提醒/计划',
      '🎬 截图/录屏（ScreenshotTool）— 基于 getDisplayMedia 的真实屏幕录制并下载 webm',
      '📊 统计面板入口 — 桌面图标复用 TokenUsagePanel，Token/用量仪表盘',
    ],
  },
  {
    version: 'v3.4.0',
    date: '2026-07-11',
    changes: [
      '📕 新增小红书获客 SOP 技能（xhs-growth-agent）— 选题→内容→发布→监控→微信跟进→CRM 六步一体化增长流水线，支持 LLM 自动生成与真实发布/微信推送开关',
      '💬 智能触发词 — 聊天输入「小红书获客/做小红书/小红书引流」等即自动按 SOP 编排运行（quick_commands 注入 xhs_growth_sop）',
      '📚 接入 clawhub 技能库 — SOP 自动读取 clawhub-bridge 真实 SKILL.md（如 xhs-publish 发布指令）注入流程',
      '🗄️ CRM 线索沉淀 — 跟进结果自动写入本地数据库 leads 表，支持打分与后续运营',
      '⚙️ 双开关设计 — 配置 DEEPSEEK_API_KEY 自动生成文案；配置 XHS_MCP_URL/WXAUTO_URL 切真实发布与微信推送，未配置则产出脚本+操作清单',
    ],
  },
  {
    version: 'v3.3.0',
    date: '2026-07-10',
    changes: [
      '🎛️ 首页右侧面板独立开关化 — 神经合成/米家/运行日志/日历/学习流 5 个卡片全部支持设置内独立显隐，实时同步、localStorage 持久化不丢记忆',
      '🐞 修复右侧面板默认值 bug — 神经合成/米家面板读取约定与设置开关统一（未设置=关闭），修复\"设置里关、桌面却全开\"',
      '🏠 米家设备面板解耦 — 从神经合成监控独立为 MijiaPanel，单独受 xf_mijia_enabled 控制，不再依赖神经合成开关',
      '📋 新增首页运行日志开关（xf_runtime_log_enabled）— 首页右侧可显示系统运行日志面板',
      '📅 新增日历开关（xf_calendar_enabled）— 控制首页右侧日期/天气/月历卡片',
      '🧠 新增学习流开关（xf_learning_flow_enabled）— 控制首页右侧\"小枫 学习流\"卡片',
    ],
  },
  {
    version: 'v3.2.5',
    date: '2026-07-09',
    changes: [
      '🌐 全页 UI 汉化收尾 — 面向用户英文文案清零，专有名词（Token/API/DeepSeek/MCP/LLM 等）保留英文',
      '🐞 Bug 扫描修复 — 上一轮批量汉化误改代码标识符（组件名/类型/prop/图标/枚举值）导致 tsc 30 错误，已全部还原',
      '🧹 半汉化脏数据清理 — 修复「搜索ing...」等中英混排脏数据，统一中文文案',
      '✅ tsc --noEmit 零错误 — 编译通过，零类型错误',
    ],
  },
  {
    version: 'v3.2.4',
    date: '2026-07-09',
    changes: [
      '🔐 token 加密存储 — 修复 v3.2.3 漏改：authService token 改为 AES 加密存储+解密读取',
      '🧩 共享加密模块 — 新建 src/utils/crypto.ts，Auth 内联加密抽出复用，密钥沿用 xf-remember-cipher-v1 兼容旧数据',
      '📝 空 catch 收尾 — 补 AppContext/useWakeWord/authService 三处真空缺日志',
      '✅ tsc --noEmit 零错误 — v3.2.3 补丁收尾',
    ],
  },
  {
    version: 'v3.2.3',
    date: '2026-07-09',
    changes: [
      '🛡️ 密码加密存储 — localStorage 密码/token 使用 CryptoJS AES 加密，不再明文存储',
      '🔑 管理员密码随机化 — 未设 AUTO_LOGIN_PASSWORD 时自动生成 16 位随机密码',
      '🔧 232 个 TypeScript 类型错误修复 — tsc --noEmit 零错误',
      '📝 空 catch 补日志 — 25 处空 catch 块补充 console.warn，提升可调试性',
      '⚡ React.memo 性能优化 — Settings/AgentChatPage/TeamHub/PixelTree/AvatarStudio 大组件包裹',
      '🧹 代码清理 — 删除 adapter_tools.ts，lumiElectron→xfElectron 命名统一',
      '📦 Tool 模块拆分 — 工具函数独立模块化',
    ],
  },
  {
    version: 'v3.2.2',
    date: '2026-07-09',
    changes: [
      '🔒 隐私安全 — 删除 generateOpenAIEmbedding()，不再将用户文本发送到 OpenAI 云端',
      '⚡ 向量检索加速 — 余弦 LSH 索引（L=8 哈希表/K=12 位），候选预筛选 + 精确余弦重排',
      '💾 存储优化 — embedding 列 TEXT→BLOB 二进制存储，减少磁盘空间',
      '🔧 启动流程 — bootstrap 启动时自动执行 embedding 迁移 + LSH 索引初始化',
    ],
  },
  {
    version: 'v3.2.1',
    date: '2026-07-08',
    changes: [
      '🧠 本地 Embedding 改造 — 采用 @xenova/transformers + paraphrase-multilingual-MiniLM-L12-v2（384维），零 API 费用，记忆向量持久化到数据库，支持本地模型→OpenAI→关键词搜索三级降级链',
      '🌐 全中文 UI 汉化 — 所有面向用户的界面文字中文化（登录/语音/控制中心等），保留 en/zh 双语翻译键',
      '🔒 限流策略优化 — 登录接口限流调整为 1 分钟内最多 20 次，避免正常登录被误锁',
    ],
  },
  {
    version: 'v3.2.0',
    date: '2026-07-08',
    changes: [
      '🧠 上下文智能压缩引擎 — 三级压缩策略（L1保留/L2 LLM压缩/L3深度压缩），对标大厂不粗暴截断',
      '⚡ 上下文预警系统 — Token用量面板三级预警（安全/黄色70%/红色90%），输入框动态警告条',
      '🔧 模型选择器增强 — 内置7大厂商完整模型目录，自动填充已配置密钥厂商所有模型',
      '📊 Token用量面板修复 — 未登录用户数据展示异常修复，30秒自动轮询',
      '🎯 maxContext 动态化 — 按模型返回真实上下文窗口（DeepSeek V4 = 1M tokens）',
      '💾 对话摘要增强 — summarizeConversation 输出结构化JSON（600 tokens），历史加载自动注入压缩统计',
    ],
  },
  {
    version: 'v3.1.1',
    date: '2026-07-06',
    changes: [
      '🧩 新增顶部 Dock 栏快捷导航（对话/技能中心/主题/截图/AI状态）',
      '🐱 迷你宠物缩略图集成到顶部导航（静态裁切，零动画开销）',
      '🔧 OOM 崩溃修复 — 移除重复 PetAvatar 实例，spritesheet 从 MB 级降到 KB 级',
      '🏠 米家 IoT 设备面板（空调+温度计 Mock 数据，2 列网格布局）',
      '📊 神经合成面板全部 Section 可折叠（System/AI/Performance/MiHome）',
      '📋 设置页新增更新日志 Tab（时间线风格版本卡片）',
      '✨ 默认桌面仅粒子特效，宠物需在形象设置中手动启用',
      '📝 补全 2.x 版本历史日志',
    ],
  },
  {
    version: 'v3.1.0',
    date: '2026-07-06',
    changes: [
      '小枫 OS v3 基础架构发布，暗色玻璃态桌面 UI',
    ],
  },
  {
    version: 'v3.0.0',
    date: '2026-07-05',
    changes: [
      '🚀 小枫 OS v3 基础架构全面重构',
      '🎨 暗色玻璃态桌面 UI（wallpaper + widget 模式）',
      '🤖 人格引擎接入（personalityRegistry 动态 system prompt）',
      '🐾 宠物精灵系统（PetAvatar + SpriteAnimator + 多宠物切换）',
      '📡 系统状态监控（CPU/RAM/GPU 实时数据）',
      '🧠 神经合成监控面板（System/AI/Performance 分区）',
      '🎤 语音交互（VoiceForge + 多 TTS 服务商切换）',
      '🔌 MCP 协议支持（工具注入 + 小模型限制）',
      '🖥️ 桌面窗口管理器（多窗口拖拽/最小化/最大化）',
    ],
  },
  {
    version: 'v2.3.0',
    date: '2026-06-28',
    changes: [
      '🎯 工具调用系统重构 — 支持 function calling + 流式输出',
      '📦 默认模型升级为 qwen3.5:9b（Q4_K_M 量化，26万 context）',
      '🔐 生物识别登录（指纹/人脸）',
    ],
  },
  {
    version: 'v2.2.0',
    date: '2026-06-22',
    changes: [
      '🎙️ Whisper 语音识别接入 — 中文/英文实时转写',
      '🗣️ Edge TTS 语音合成 — 多音色可选',
      '💬 对话历史管理 — 本地 SQLite 持久化',
      '📱 PWA 渐进式 Web 应用支持',
    ],
  },
  {
    version: 'v2.1.0',
    date: '2026-06-18',
    changes: [
      '🧩 插件系统 v1 — 支持动态加载/卸载插件',
      '📝 Markdown 渲染引擎 — 代码高亮 + LaTeX 数学公式',
      '🌐 i18n 国际化框架 — 中文/英文双语切换',
      '🔔 桌面通知系统 — 浏览器 Notification API',
    ],
  },
  {
    version: 'v2.0.0',
    date: '2026-06-15',
    changes: [
      '🎉 小枫 OS v2 正式发布',
      '🖥️ React + TypeScript 单页应用架构',
      '🎨 暗色主题 + 玻璃态 UI 设计语言',
      '📂 文件管理系统 + 代码编辑器',
    ],
  },
];

/** 获取最新版本的变更日志 */
export function getLatestChangelog(): ChangelogEntry | null {
  return CHANGELOG.length > 0 ? CHANGELOG[0] : null;
}

/** 获取所有版本日志 */
export function getAllChangelog(): ChangelogEntry[] {
  return [...CHANGELOG];
}
